module.exports = __webpack_public_path__ + "static/media/tutorial_next.610e3441.png";